import { IApiResponse } from './../../../interfaces/IApiResponse';
import { IRelatorioFranquiaGlobalResponseData } from './../../../interfaces/relatorio/FranquiaGlobal/IRelatorioFranquiaGlobalResponseData';
import { IRelatorioFranquiaGlobalBody } from './../../../interfaces/relatorio/FranquiaGlobal/IRelatorioFranquiaGlobalBody';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RelatorioFranquiaGlobalService {
  private readonly baseURL = '/RelatorioFranquiaGlobal';

  constructor(private httpClient: HttpClient) {}

  postRelatorioFranquiaGlobal(body: IRelatorioFranquiaGlobalBody) {
    return this.httpClient.post<
      IApiResponse<IRelatorioFranquiaGlobalResponseData>
    >(this.baseURL, body);
  }
}
